import React, { useRef, useState, useEffect } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import './CinematicBanner.css';

export default function CinematicBanner() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  const [playing, setPlaying] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  // 🔥 Fetch video from WordPress
  useEffect(() => {
    fetch("https://admin.jksjewels.com/wp-json/wp/v2/pages/46")
      .then(res => res.json())
      .then(data => {
        const url = data?.acf?.banner_video;
        console.log("VIDEO URL:", url); // debug
        setVideoUrl(url);
      })
      .catch(err => console.error(err));
  }, []);

  // 🔥 Robust YouTube ID extractor
  const getYoutubeId = (url) => {
    if (!url) return "";

    // Shorts URL
    if (url.includes("shorts")) {
      return url.split("shorts/")[1]?.split(/[?&]/)[0];
    }

    // Normal YouTube URL
    if (url.includes("v=")) {
      return url.split("v=")[1]?.split("&")[0];
    }

    return "";
  };

  const videoId = getYoutubeId(videoUrl);

  console.log("VIDEO ID:", videoId); // debug

  const togglePlay = () => {
    setPlaying(true);
  };

  return (
    <section className="cinematic" ref={ref}>
      <div className={`cinematic__inner${visible ? ' visible' : ''}`}>

        {/* 🎬 VIDEO (only after click) */}
        {videoUrl && videoId && playing && (
          <iframe
            className="cinematic__bg"
            title="JKS Jewellery Video Banner"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&playsinline=1&rel=0`}
            frameBorder="0"
            allow="autoplay; encrypted-media; fullscreen"
          />
        )}

        <div className="cinematic__overlay" />

        {/* ▶️ Play Button */}
        {!playing && (
          <div className="cinematic__center">
            <button
              className="cinematic__play"
              onClick={togglePlay}
              aria-label="Play video"
            >
              <span className="cinematic__play-ring cinematic__play-ring--1" />
              <span className="cinematic__play-ring cinematic__play-ring--2" />

              <svg
                className="cinematic__play-icon"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path d="M9 5l14 8-14 8V5z" fill="white" />
              </svg>
            </button>
          </div>
        )}

      </div>
    </section>
  );
}